import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../context/GlobalContext";
import ProjectShort from "./ProjectShort";

function Projects() {
    
    const {section, projectsData, showElement } = useContext(GlobalContext)

    useEffect(() => {

    }, [section])

    console.log(section);

    return(
        <div className="projects">
            <h3 className="projects__title">{section}</h3>

            <div className="projects__projectsList">
                {projectsData.map((proj) =>{
                    console.log(proj);
                    return(
                        <div className="projects__element">
                            <h5 className="projects__subtitle listItem" id={"sub" + proj.id.split(' ').join('')} onClick={() => showElement(proj.id)}>{proj.id}  +</h5>
                            <div id={proj.id.split(' ').join('')} className="projects__details listDetail">
                                <ProjectShort
                                    desc = {proj.shortDesc}
                                    id = {proj.id}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>    
        </div>
    )
}

export default Projects